var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLargeArrowBottomLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7256 28.2187L34.9256 17.1187L36.4743 18.6812L25.2778 29.7778C25.2771 29.7784 25.2765 29.779 25.2759 29.7797C24.8398 30.2148 24.2679 30.475 23.6499 30.475C23.0311 30.475 22.4584 30.2141 22.0221 29.7778L10.9221 18.6778L12.4778 17.1221L23.5778 28.2221C23.6116 28.256 23.6357 28.2685 23.6448 28.2724C23.647 28.2734 23.6487 28.274 23.6499 28.2744C23.6512 28.274 23.6529 28.2734 23.6551 28.2724C23.6642 28.2685 23.6883 28.256 23.7221 28.2221L23.7256 28.2186L23.7256 28.2187Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargeArrowBottomLight);
export default __webpack_public_path__ + "static/media/icon_large_arrow_bottom_light.5cc25853.svg";
export { ForwardRef as ReactComponent };